import { render, staticRenderFns } from "./BatchModifyDelete.vue?vue&type=template&id=407b9d8b&scoped=true"
import script from "./BatchModifyDelete.vue?vue&type=script&lang=js"
export * from "./BatchModifyDelete.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyDelete.vue?vue&type=style&index=0&id=407b9d8b&prod&scoped=true&lang=css"
import style1 from "./BatchModifyDelete.vue?vue&type=style&index=1&id=407b9d8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b9d8b",
  null
  
)

export default component.exports